import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';

const BlurOverlay = ({ influencerUsername }) => {
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    navigate('/pricing');
  };

  return (
    <div className="absolute inset-0 bg-white/80 backdrop-blur-sm z-10 flex items-center justify-center rounded-xl">
      <div className="text-center p-6 max-w-sm">
        <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
          <Lock className="w-8 h-8 text-gray-600" />
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">
          Upgrade to Access Profile
        </h3>
        <p className="text-gray-600 mb-6">
          Upgrade your plan to view detailed influencer profiles and analytics.
        </p>
        <button
          onClick={handleUpgradeClick}
          className="px-6 py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition font-semibold"
        >
          View Plans & Upgrade
        </button>
      </div>
    </div>
  );
};

export default BlurOverlay;
